import { render, staticRenderFns } from "./GtcDonationView.vue?vue&type=template&id=7047ec24&scoped=true"
import script from "./GtcDonationView.vue?vue&type=script&lang=js"
export * from "./GtcDonationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7047ec24",
  null
  
)

export default component.exports